// Common request states
export const ADMIN_REQUEST_START = "ADMIN_REQUEST_START";
export const ADMIN_REQUEST_SUCCESS = "ADMIN_REQUEST_SUCCESS";
export const ADMIN_REQUEST_FAIL = "ADMIN_REQUEST_FAIL";
export const ADMIN_CLEAR_ERROR = "ADMIN_CLEAR_ERROR";
export const ADMIN_CLEAR_SUCCESS = "ADMIN_CLEAR_SUCCESS";

// Brands
export const BRANDS_FETCH_SUCCESS = "BRANDS_FETCH_SUCCESS";
export const BRAND_CREATE_SUCCESS = "BRAND_CREATE_SUCCESS";
export const BRAND_UPDATE_SUCCESS = "BRAND_UPDATE_SUCCESS";
export const BRAND_DELETE_SUCCESS = "BRAND_DELETE_SUCCESS";
export const BRAND_DETAIL_SUCCESS = "BRAND_DETAIL_SUCCESS";

// Sub Brands
export const SUB_BRANDS_LOADING_START = "SUB_BRANDS_LOADING_START";
export const SUB_BRANDS_FETCH_SUCCESS = "SUB_BRANDS_FETCH_SUCCESS";
export const SUB_BRAND_CREATE_SUCCESS = "SUB_BRAND_CREATE_SUCCESS";
export const SUB_BRAND_UPDATE_SUCCESS = "SUB_BRAND_UPDATE_SUCCESS";
export const SUB_BRAND_DELETE_SUCCESS = "SUB_BRAND_DELETE_SUCCESS";
export const SUB_BRAND_DETAIL_SUCCESS = "SUB_BRAND_DETAIL_SUCCESS";

// Categories
export const CATEGORIES_LOADING_START = "CATEGORIES_LOADING_START";
export const CATEGORIES_FETCH_SUCCESS = "CATEGORIES_FETCH_SUCCESS";
export const CATEGORY_CREATE_SUCCESS = "CATEGORY_CREATE_SUCCESS";
export const CATEGORY_UPDATE_SUCCESS = "CATEGORY_UPDATE_SUCCESS";
export const CATEGORY_DELETE_SUCCESS = "CATEGORY_DELETE_SUCCESS";
export const CATEGORY_DETAIL_SUCCESS = "CATEGORY_DETAIL_SUCCESS";

// Sub-Brand Vendors
export const VENDORS_LOADING_START = "VENDORS_LOADING_START";
export const VENDORS_FETCH_SUCCESS = "VENDORS_FETCH_SUCCESS";
export const VENDOR_CREATE_SUCCESS = "VENDOR_CREATE_SUCCESS";
export const VENDOR_UPDATE_SUCCESS = "VENDOR_UPDATE_SUCCESS";
export const VENDOR_DELETE_SUCCESS = "VENDOR_DELETE_SUCCESS";
export const VENDOR_DETAIL_SUCCESS = "VENDOR_DETAIL_SUCCESS";

// Vendor/Wallet
export const VENDOR_DETAILS_FETCH_SUCCESS = "VENDOR_DETAILS_FETCH_SUCCESS";
export const VENDOR_DETAILS_UPDATE_SUCCESS = "VENDOR_DETAILS_UPDATE_SUCCESS";

// Orders
export const ORDERS_LOADING_START = "ORDERS_LOADING_START";
export const ORDERS_FETCH_SUCCESS = "ORDERS_FETCH_SUCCESS";
export const ORDER_DETAIL_SUCCESS = "ORDER_DETAIL_SUCCESS";
export const ORDERS_CLEAR = "ORDERS_CLEAR";
export const ORDER_UPDATE_SUCCESS = "ORDER_UPDATE_SUCCESS";

// Transactions
export const TRANSACTIONS_LOADING_START = "TRANSACTIONS_LOADING_START";
export const TRANSACTIONS_FETCH_SUCCESS = "TRANSACTIONS_FETCH_SUCCESS";
export const TRANSACTIONS_CLEAR = "TRANSACTIONS_CLEAR";